"use strict";
exports.__esModule = true;
exports.notKeyword = void 0;
var utils_1 = require("../../utils");
var factory_1 = require("../factory");
var validation_1 = require("../validation");
var keywords = [
    'asc',
    'date_created',
    'date_modified',
    'desc',
    'file',
    'id',
    'length',
    'node_def_uuid',
    'owner_uuid',
    'parent_id',
    'parent_uuid',
    'props',
    'props_draft',
    'props_advanced',
    'record_uuid',
    'step',
    'uuid',
    'value',
];
var notKeyword = function (messageKey) { return function (field, obj) {
    var value = utils_1.Objects.path(field)(obj);
    var valid = utils_1.Objects.isEmpty(value) || !keywords.includes(value);
    return factory_1.ValidationResultFactory.createInstance({
        valid: valid,
        messageKey: messageKey,
        severity: validation_1.ValidationSeverity.error
    });
}; };
exports.notKeyword = notKeyword;
//# sourceMappingURL=notKeyword.js.map